<template>
  <div v-if="event.hasOwnProperty('id')">
    <h1>{{ event.title }}</h1>
    <strong>{{ event.organizer }}</strong>
    <p>{{ event.time }} on {{ event.date }} @ {{ event.location }}</p>
    <p>{{ event.description }}</p>
  </div>
</template>

<script lang="ts">
/* eslint-disable no-unused-vars */
import { ref, defineComponent } from 'vue'
import { EventItem } from '../types'
import EventService from '../services/EventService'
export default defineComponent({
  props: {
    id: {
      type: String
    }
  },
  setup(props) {
    const event = ref({} as EventItem)
    const eventService = EventService.getEvent(props.id)
      .then(response => {
        event.value = response.data
      })
      .catch(error => {
        console.log(error)
      })

    return {
      event,
      eventService
    }
  }
})
</script>
